import React from 'react';
import Anchor from '@om-fe/core/components/anchor/anchor';
import { RouteNames } from '@om-fe/core/core/routing/utils';
import { BemModifier } from '@om-fe/utils';
import { FlagIcon, FlagIconLocations } from '@om-fe/widgets/dist/components/icon/flag-icon';
import { bemSlider } from '@om-fe/widgets/dist/components/slider/slider.constants';
import { NextRaceTab } from './next-race-event-list-page';

interface NavItemPublicProps {
    readonly navName: string;
    readonly activeTab?: string;
    readonly handleClickAnchor: (navName: string) => void;
}

export function NextRaceNavItem({navName, activeTab, handleClickAnchor}: NavItemPublicProps) {
    return (
        <Anchor
            extraClassName={bemSlider('Action')}
            activeClassName={BemModifier.Active}
            routeName={RouteNames}
            isActive={activeTab === navName}
            preventRedirect={true}
            handleClickAnchor={() => handleClickAnchor(navName)}
        >
            {navName === NextRaceTab.UK && (
              <span className={bemSlider('ItemIcon')}>
                <FlagIcon locationId={FlagIconLocations.UK} />
              </span>
            )}
            {navName === NextRaceTab.France && (
                <span className={bemSlider('ItemIcon')}>
                    <FlagIcon locationId={FlagIconLocations.France} />
                </span>
            )}
            {navName === NextRaceTab.US && (
                <span className={bemSlider('ItemIcon')}>
                    <FlagIcon locationId={FlagIconLocations.US} />
                </span>
            )}
            <div className={bemSlider('ItemText')}>
                {navName}
            </div>
        </Anchor>
    );
}
